import React, { useEffect } from 'react';
import { t, Trans } from '@lingui/macro';
import PropTypes from 'prop-types';
import { Flex, Grid, H3, P, TextField, Toggle } from '@decisiv/ui-components';
import SectionRow from '../../components/SectionRow';
import { FormGroup } from '../IntegrationDetailPage/StyledComponents';
import {
  MAX_FAILURE_THRESHOLD_LENGTH,
  MAX_RETRY_AFTER_LENGTH,
} from '../../common/constants/maxLengthValues';

export default function CircuitBreaker({
  handleForm,
  showFields,
  circuitBreakerEnabled,
}) {
  const customEvent = (value, name) => ({ target: { value, name } });

  const handleRetryAfterChange = (e) => {
    if (e.target.value.length > MAX_RETRY_AFTER_LENGTH) {
      e.target.value = e.target.value.slice(0, MAX_RETRY_AFTER_LENGTH);
    }
    handleForm({ event: e });
  };

  const handleFailureThresholdChange = (e) => {
    if (e.target.value.length > MAX_FAILURE_THRESHOLD_LENGTH) {
      e.target.value = e.target.value.slice(0, MAX_FAILURE_THRESHOLD_LENGTH);
    }
    handleForm({ event: e });
  };

  useEffect(() => {
    // eslint-disable-next-line
  }, []);

  return (
    <SectionRow>
      <Grid.Column padding={0} span="3">
        <H3>
          <Trans>Circuit Breaker</Trans>
        </H3>
      </Grid.Column>
      <Grid.Column padding={0}>
        <P shade={1} size="small" marginBottom={1}>
          <Trans>
            When enabled, the Circuit Breaker will trigger when the failure
            threshold is reached for specific errors. When this happens, the
            integration won&apos;t process new requests.
          </Trans>
        </P>
        <FormGroup key="circuitBreaker">
          <Toggle
            name="circuit_breaker_enabled"
            options={[
              {
                id: 'disabled',
                text: t`Disabled`,
              },
              { id: 'enabled', text: t`Enabled` },
            ]}
            onChange={(e) => {
              let convertedValue = false;
              convertedValue = e === 'enabled';
              handleForm({
                event: customEvent(convertedValue, 'circuit_breaker_enabled'),
              });
            }}
            selected={circuitBreakerEnabled ? 'enabled' : 'disabled'}
          />
          {showFields ? (
            <FormGroup>
              <TextField
                label={t`Circuit Breaker Retry After`}
                name={t`circuit_breaker_retry_after`}
                required
                type="number"
                defaultValue={60}
                onChange={handleRetryAfterChange}
              />
              <Flex marginTop={1}>
                <TextField
                  label={t`Circuit Breaker Failure Threshold`}
                  name={t`circuit_breaker_failure_threshold`}
                  required
                  type="number"
                  defaultValue={5}
                  onChange={handleFailureThresholdChange}
                />
              </Flex>
            </FormGroup>
          ) : null}
        </FormGroup>
      </Grid.Column>
    </SectionRow>
  );
}
CircuitBreaker.propTypes = {
  handleForm: PropTypes.func.isRequired,
  showFields: PropTypes.bool.isRequired,
  circuitBreakerEnabled: PropTypes.bool.isRequired,
};
